import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Card,
  Typography,
  CardContent,
} from "@mui/material";
import { ArrowBack, Receipt } from "@mui/icons-material";
import api from "../../../services/api";
import { useAuth } from "../../../hooks/auth";

export const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const { cookies } = useAuth();

  const transactionList = (transactions) => {
    // const transactionArray = transactions.reverse();
    // console.log(transactionArray.length)
    const list = transactions
      .slice(0)
      .reverse()
      .map((value, index) => {
        const date_time = new Date(value.createdAt);
        const year = date_time.getFullYear();
        const month = date_time.getMonth() + 1;
        const day = date_time.getDate();
        const hours = date_time.getHours();
        const minutes = date_time.getMinutes();
        const seconds = date_time.getSeconds();
        return (
          <Card
            key={index}
            sx={{
              minWidth: 325,
              maxWidth: 600,
              boxShadow: "2px 2px 9px -4px rgba(0,0,0,0.75)",
            }}
          >
            <CardContent>
              <Stack spacing={1}>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>{`${day}-${month}-${year} ${hours}:${minutes}:${seconds}`}</Typography>
                  <Typography>{value.meal_type}</Typography>
                </Box>
                <Divider />
                <Typography component="div">{value.food_name}</Typography>
                <Typography color="text.secondary">
                  Attendant: {value.attendant_name}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        );
      });
    return (
      <Stack px="15px" pt="10px" spacing={2}>
        {list}
      </Stack>
    );
  };

  const nilTransactions = () => {
    return (
      <Box
        sx={{
          color: "rgba(48, 54, 70, 0.3)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          position: "absolute",
          top: "40%",
        }}
      >
        <Stack spacing={2}>
          <Receipt sx={{ fontSize: "100px", margin: "auto" }} />
          <Typography variant="subtitle2">
            No transaction has been recorded.
            <br />
            Go get your meal.
          </Typography>
        </Stack>
      </Box>
    );
  };

  const getTransactions = async () => {
    try {
      const response = await api.get(`/transactions/${cookies.data._id}`, {
        headers: {
          Authorization: `Bearer ${cookies.data.token}`,
        },
      });
      setTransactions(response.data.data);
      console.log(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getTransactions();
  }, []);

  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate("/more");
  };

  console.log(transactions);

  return (
    <Box sx={{ width: "100%" }}>
      <AppBar position="sticky">
        <Toolbar disableGutters={true}>
          <Stack
            direction="row"
            sx={{
              display: "flex",
              alignItems: "center",
              color: "white",
            }}
          >
            <IconButton
              aria-label="go back"
              sx={{
                paddingLeft: "10px",
                paddingRight: "10px",
                color: "white",
              }}
              onClick={handleGoBack}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h5">Transaction History</Typography>
          </Stack>
        </Toolbar>
      </AppBar>
      {transactions.length > 0
        ? transactionList(transactions)
        : nilTransactions()}
    </Box>
  );
};
